/* eslint-disable complexity */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-handler-names */
/* eslint-disable max-lines-per-function */

import { InputText } from "@bluframe/blublocks"
import Autosuggest from "components/Autosuggest"
import Button from "components/buttons/Button"
import ImageSelector from "components/ImageSelector"
import CollapsibleTextArea from "components/inputs/CollapsibleTextArea"
import InputDate from "components/inputs/Date"
import Select from "components/inputs/Select"
import Text from "components/inputs/Text"
import Layout from "components/Layout"
import TechSpecsSelector from "components/TechSpecs/Selector"
import TMDBSearchDropdown from "components/TMDBSearchDropdown"

import { ComponentProps } from "."
import { Wrapper } from "./styled"

const AddActions = ({
  IMDb,
  additionalInstructionsRef,
  contentAuthors,
  imageSelector,
  isAddItemEnabled,
  isAdditionalInstructions,
  isAdmin,
  isEditor,
  gridTemplateColumns = "1fr",
  isSingleSource,
  label,
  loading,
  name,
  newsSourceLinkRef,
  onAddItem,
  onClearAll,
  onContentAuthorSelect,
  onNewsSourceUrlChange,
  onNameChange,
  onSetReleaseDate,
  onSingleSourceSuggestionClick,
  releaseDate,
  searchHomeVideo,
  searchNewsSource,
  serviceType,
  screenshotSelector,
  techSpecsSelector
}: ComponentProps) => (
  <Wrapper $gridTemplateColumns={gridTemplateColumns}>
    <Layout.Row>
      {searchHomeVideo?.isSearchHomeVideo &&
      searchHomeVideo?.onGetHomeVideoSuggestions &&
      searchHomeVideo?.onSelectHomeVideoId ? (
        <Autosuggest
          isLoading={searchHomeVideo.isLoading}
          label="Search for a Home Video"
          onGetSuggestions={searchHomeVideo?.onGetHomeVideoSuggestions}
          onSuggestionClick={searchHomeVideo?.onSelectHomeVideoId}
          suggestions={searchHomeVideo?.homeVideoTitles}
          value={searchHomeVideo?.selectedHomeVideoId}
        />
      ) : IMDb ? (
        <TMDBSearchDropdown
          disabled={loading}
          hasSelectedIcon={IMDb.hasSelectedIcon}
          label="Search TMDB"
          loading={IMDb.tmdbLoading || false}
          onSearch={IMDb.onTmdbSearch}
          onSelect={
            IMDb.onTmdbSelect || IMDb.onImdbIdChange || (() => undefined)
          }
          selected={IMDb.tmdbSelectedId}
          suggestions={IMDb.tmdbSuggestions || []}
          type="both"
        />
      ) : null}

      <Button
        bold
        disabled={!isAddItemEnabled || loading}
        label={label}
        loading={loading}
        onClick={onAddItem}
      />

      <Button
        bold
        disabled={loading}
        label="Clear All"
        onClick={onClearAll}
        secondary
      />
    </Layout.Row>

    <Layout.Row>
      {isAdmin || isEditor ? (
        <Text
          disabled={loading}
          id="name"
          label="Name"
          name="name"
          onChange={onNameChange}
          text={name}
        />
      ) : null}

      {(isAdmin || isEditor) &&
      serviceType === "news" &&
      contentAuthors &&
      onContentAuthorSelect ? (
        <Select
          label="Author"
          name="author"
          onChange={onContentAuthorSelect}
          options={contentAuthors.map((author) => ({
            label: author.name,
            value: author.id
          }))}
        />
      ) : null}
    </Layout.Row>

    {(isAdmin || isEditor) && isSingleSource && searchNewsSource ? (
      <Layout.Row>
        <Autosuggest
          hasSelectedIcon
          inputId="search-news-source"
          isLoading={searchNewsSource.isLoading}
          label="Search for a News Source"
          onGetSuggestions={searchNewsSource.onGetSuggestions}
          onSuggestionClick={onSingleSourceSuggestionClick}
          suggestions={[
            ...(searchNewsSource.labels ?? []),
            ...(searchNewsSource.outlets ?? [])
          ]}
          value={searchNewsSource.selectedId}
        />

        <InputText
          inputId="search-news-source-url"
          label="Url"
          name="url"
          onChange={onNewsSourceUrlChange}
          ref={newsSourceLinkRef}
        />
      </Layout.Row>
    ) : null}

    <Layout.Row>
      {(isAdmin || isEditor) && imageSelector ? (
        <ImageSelector {...imageSelector} />
      ) : null}

      {(isAdmin || isEditor) && screenshotSelector ? (
        <ImageSelector {...screenshotSelector} mediaLabel="Screenshots" />
      ) : null}

      {(isAdmin || isEditor) && techSpecsSelector ? (
        <TechSpecsSelector {...techSpecsSelector} />
      ) : null}
    </Layout.Row>

    <Layout.Row>
      {(isAdmin || isEditor) && serviceType === "news" && onSetReleaseDate ? (
        <InputDate
          label="Release Date"
          onChange={onSetReleaseDate}
          value={releaseDate}
        />
      ) : null}

      {(isAdmin || isEditor) && isAdditionalInstructions ? (
        <CollapsibleTextArea
          id="additional-instructions"
          label="Additional Instructions"
          name="additionalInstructions"
          rows={5}
          textAreaRef={additionalInstructionsRef}
        />
      ) : null}
    </Layout.Row>
  </Wrapper>
)

export default AddActions
